// "Script error." type errors ignored by default already
export const IGNORE_ERRORS_REGEXES = [
  /Search term change/,
  /svgMapUrl not available/,
  /AbortError/,
  /Fetch is aborted/,
  /Debounce cancelled overlapping requests in FloatingSearch/,
  // These are not errors/logs, these should be page events
  /^Apple Pay option was shown to user/,
  // reCAPTCHA timeout errors from cross-origin iframe (harmless)
  /non-error promise rejection captured with value: timeout/i,
  /bframe.*timeout/i,
  /recaptcha.*timeout/i,
  // CSS Selectors Level 4 SyntaxError on unsupported browsers (tabbable@6.4.0 inert selectors)
  /Failed to execute 'matches' on 'Element'.*\[inert]/,
  // DRM/EME errors from cross-origin ad iframes — third-party Widevine CDM failures, no user impact (WEBSITE-DISCOVER-QMY, QHW, 72)
  /Failed to execute '\w+' on 'MediaKeySession'/,
];

export const DENY_URLS_REGEXES = [
  // AWS WAF challenge SDK throws internally for clients that fail its device check; third-party, not actionable
  /\/challenge\.compact\.js/,
];
